// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { AcceptInvitationData, AcceptInvitationErrors, AcceptInvitationResponses, AcknowledgeEventData, AcknowledgeEventResponses, ActivateUserData, ActivateUserErrors, ActivateUserResponses, ApproveTrialSetupRequestData, ApproveTrialSetupRequestErrors, ApproveTrialSetupRequestResponses, AssignmentTimelineData, AssignmentTimelineErrors, AssignmentTimelineResponses, AuditEventsData, AuditEventsErrors, AuditEventsResponses, AuthFinishData, AuthFinishErrors, AuthFinishResponses, AuthStartData, AuthStartResponses, AutosaveData, AutosaveErrors, AutosaveResponses, BatteryTrendData, BatteryTrendErrors, BatteryTrendResponses, BulkAcknowledgeData, BulkAcknowledgeResponses, BulkImportParticipantsData, BulkImportParticipantsErrors, BulkImportParticipantsResponses, BulkSendData, BulkSendErrors, BulkSendResponses, BulkValidateData, BulkValidateErrors, BulkValidateResponses, ChangePasswordData, ChangePasswordErrors, ChangePasswordResponses, ChangeTrialStatusData, ChangeTrialStatusErrors, ChangeTrialStatusResponses, CheckMyPermissionsData, CheckMyPermissionsErrors, CheckMyPermissionsResponses, CheckPermissionsData, CheckPermissionsErrors, CheckPermissionsResponses, CompleteEnrollmentData, CompleteEnrollmentErrors, CompleteEnrollmentResponses, ConnectionLogsData, ConnectionLogsErrors, ConnectionLogsResponses, CreateAssignmentData, CreateAssignmentErrors, CreateAssignmentResponses, CreateCohortData, CreateCohortErrors, CreateCohortResponses, CreateContactData, CreateContactResponses, CreateMedicationData, CreateMedicationErrors, CreateMedicationResponses, CreateOrganizationData, CreateOrganizationErrors, CreateOrganizationResponses, CreateParticipantData, CreateParticipantErrors, CreateParticipantResponses, CreateProfileData, CreateProfileResponses, CreateSiteData, CreateSiteErrors, CreateSiteResponses, CreateTrialData, CreateTrialErrors, CreateTrialResponses, CreateTrialSetupRequestData, CreateTrialSetupRequestErrors, CreateTrialSetupRequestResponses, CsrfTokenData, CsrfTokenResponses, DeactivateUserData, DeactivateUserErrors, DeactivateUserResponses, DeleteCohortData, DeleteCohortErrors, DeleteCohortResponses, DeleteContactData, DeleteContactResponses, DeleteMedicationData, DeleteMedicationErrors, DeleteMedicationNestedData, DeleteMedicationNestedErrors, DeleteMedicationNestedResponses, DeleteMedicationResponses, DeleteOrganizationData, DeleteOrganizationErrors, DeleteOrganizationResponses, DeleteParticipantData, DeleteParticipantErrors, DeleteParticipantResponses, DeletePasskeyData, DeletePasskeyErrors, DeletePasskeyResponses, DeleteProfileData, DeleteProfileResponses, DeleteSiteData, DeleteSiteErrors, DeleteSiteResponses, DeleteTrialData, DeleteTrialErrors, DeleteTrialParticipantData, DeleteTrialParticipantErrors, DeleteTrialParticipantResponses, DeleteTrialResponses, DeleteTrialSetupRequestData, DeleteTrialSetupRequestErrors, DeleteTrialSetupRequestResponses, DeleteUserData, DeleteUserErrors, DeleteUserResponses, DeviceHealthSummaryData, DeviceHealthSummaryResponses, Disable2FaData, Disable2FaErrors, Disable2FaResponses, DownloadAttachmentData, DownloadAttachmentResponses, Enable2FaData, Enable2FaErrors, Enable2FaResponses, EnrollData, EnrollErrors, EnrollPassphraseData, EnrollPassphraseErrors, EnrollPassphraseResponses, EnrollResponses, ExportAuditLogs2Data, ExportAuditLogs2Errors, ExportAuditLogs2Responses, ExportAuditLogs3Data, ExportAuditLogs3Errors, ExportAuditLogs3Responses, ExportAuditLogsData, ExportAuditLogsErrors, ExportAuditLogsResponses, ExportDeliveriesData, ExportDeliveriesResponses, ExportUsersData, ExportUsersErrors, ExportUsersResponses, Generate2FaData, Generate2FaErrors, Generate2FaResponses, GenerateEnrollmentFormsData, GenerateEnrollmentFormsErrors, GenerateEnrollmentFormsResponses, GetAccessibleResourcesData, GetAccessibleResourcesErrors, GetAccessibleResourcesResponses, GetByTrialAndSerialData, GetByTrialAndSerialErrors, GetByTrialAndSerialResponses, GetCohortData, GetCohortErrors, GetCohortResponses, GetDeliveryContentData, GetDeliveryContentResponses, GetDeliveryData, GetDeliveryResponses, GetDetailedData, GetDetailedErrors, GetDetailedResponses, GetEnrollmentData, GetEnrollmentErrors, GetEnrollmentResponses, GetEventData, GetEventResponses, GetEventSummaryData, GetEventSummaryResponses, GetMapsTokenData, GetMapsTokenErrors, GetMapsTokenResponses, GetMeData, GetMedicationData, GetMedicationErrors, GetMedicationNestedData, GetMedicationNestedErrors, GetMedicationNestedResponses, GetMedicationResponses, GetMedicationSlots2Data, GetMedicationSlots2Errors, GetMedicationSlots2Responses, GetMedicationSlotsData, GetMedicationSlotsErrors, GetMedicationSlotsResponses, GetMeErrors, GetMeResponses, GetMetadata2Data, GetMetadata2Errors, GetMetadata2Responses, GetMetadataData, GetMetadataErrors, GetMetadataResponses, GetMyAccessibleResourcesData, GetMyAccessibleResourcesErrors, GetMyAccessibleResourcesResponses, GetMyPermissionsData, GetMyPermissionsErrors, GetMyPermissionsResponses, GetOrganizationBySlugData, GetOrganizationBySlugErrors, GetOrganizationBySlugResponses, GetOrganizationDashboardData, GetOrganizationDashboardErrors, GetOrganizationDashboardResponses, GetOrganizationData, GetOrganizationErrors, GetOrganizationResponses, GetParticipantAdherenceData, GetParticipantAdherenceErrors, GetParticipantAdherenceResponses, GetParticipantBySlugData, GetParticipantBySlugErrors, GetParticipantBySlugResponses, GetParticipantData, GetParticipantErrors, GetParticipantHealthData, GetParticipantHealthErrors, GetParticipantHealthResponses, GetParticipantResponses, GetPopulationAdherenceData, GetPopulationAdherenceErrors, GetPopulationAdherenceResponses, GetProfile2Data, GetProfile2Responses, GetProfileData, GetProfileErrors, GetProfileResponses, GetPushStatusData, GetPushStatusResponses, GetSettingsData, GetSettingsResponses, GetSiteData, GetSiteErrors, GetSiteResponses, GetSubmissionData, GetSubmissionErrors, GetSubmissionResponses, GetTrialBySlugData, GetTrialBySlugErrors, GetTrialBySlugResponses, GetTrialData, GetTrialErrors, GetTrialLiveFeedData, GetTrialLiveFeedErrors, GetTrialLiveFeedResponses, GetTrialParticipantData, GetTrialParticipantErrors, GetTrialParticipantResponses, GetTrialResponses, GetTrialSetupRequestData, GetTrialSetupRequestErrors, GetTrialSetupRequestResponses, GetUnreadCountData, GetUnreadCountResponses, GetUserPermissionsData, GetUserPermissionsErrors, GetUserPermissionsResponses, GetUserStatisticsData, GetUserStatisticsErrors, GetUserStatisticsResponses, GrantPermissionsData, GrantPermissionsErrors, GrantPermissionsResponses, HeartbeatData, HeartbeatErrors, HeartbeatResponses, ListAuditLogs2Data, ListAuditLogs2Errors, ListAuditLogs2Responses, ListAuditLogsData, ListAuditLogsErrors, ListAuditLogsResponses, ListCohortsData, ListCohortsResponses, ListContactsData, ListContactsResponses, ListDeliveriesData, ListDeliveriesResponses, ListDeliveryAttachmentsData, ListDeliveryAttachmentsResponses, ListDispensersAliasData, ListDispensersAliasResponses, ListDispensersData, ListDispensersResponses, ListEventsData, ListEventsResponses, ListInvitationsData, ListInvitationsErrors, ListInvitationsResponses, ListMedicationsData, ListMedicationsResponses, ListNotificationsData, ListNotificationsResponses, ListOrganizationsData, ListOrganizationsResponses, ListParticipantsData, ListParticipantsResponses, ListPasskeysData, ListPasskeysErrors, ListPasskeysResponses, ListPermissionsData, ListPermissionsErrors, ListPermissionsResponses, ListProfilesData, ListProfilesResponses, ListSitesData, ListSitesResponses, ListTrialsData, ListTrialSetupRequestsData, ListTrialSetupRequestsResponses, ListTrialsResponses, ListUsersData, ListUsersErrors, ListUsersResponses, Login2FaData, Login2FaErrors, Login2FaResponses, LoginData, LoginErrors, LoginResponses, LogoutData, LogoutErrors, LogoutResponses, MarkAllAsReadData, MarkAllAsReadResponses, MarkAsReadData, MarkAsReadResponses, PasswordRecoveryData, PasswordRecoveryResponses, PasswordResetData, PasswordResetErrors, PasswordResetResponses, PreviewProfileData, PreviewProfileResponses, PushSendData, PushSendResponses, RefreshData, RefreshErrors, RefreshResponses, RegisterFinishData, RegisterFinishErrors, RegisterFinishResponses, RegisterPushTokenData, RegisterPushTokenErrors, RegisterPushTokenResponses, RegisterStartData, RegisterStartErrors, RegisterStartResponses, RejectTrialSetupRequestData, RejectTrialSetupRequestErrors, RejectTrialSetupRequestResponses, RequestVerificationData, RequestVerificationErrors, RequestVerificationResponses, ResetParticipantEnrollmentData, ResetParticipantEnrollmentErrors, ResetParticipantEnrollmentResponses, ResetTrialEnrollmentData, ResetTrialEnrollmentErrors, ResetTrialEnrollmentResponses, ResolveEventData, ResolveEventResponses, RevokeInvitationData, RevokeInvitationErrors, RevokeInvitationResponses, RevokePermissionsData, RevokePermissionsErrors, RevokePermissionsResponses, SendInvitationData, SendInvitationErrors, SendInvitationResponses, SendParticipantPushData, SendParticipantPushResponses, SendStudyMessageData, SendStudyMessageErrors, SendStudyMessageResponses, SubmitData, SubmitErrors, SubmitResponses, SubmitTrialSetupRequestData, SubmitTrialSetupRequestErrors, SubmitTrialSetupRequestResponses, SyncBatteryData, SyncBatteryErrors, SyncBatteryResponses, SyncBulkData, SyncBulkErrors, SyncBulkResponses, SyncEventsData, SyncEventsErrors, SyncEventsResponses, TestSendProfileData, TestSendProfileResponses, UnarchiveCohortData, UnarchiveCohortErrors, UnarchiveCohortResponses, UnarchiveOrganizationData, UnarchiveOrganizationErrors, UnarchiveOrganizationResponses, UnarchiveParticipantData, UnarchiveParticipantErrors, UnarchiveParticipantResponses, UnarchiveSiteData, UnarchiveSiteErrors, UnarchiveSiteResponses, UnarchiveTrialData, UnarchiveTrialErrors, UnarchiveTrialResponses, UnassignData, UnassignErrors, UnassignResponses, UnenrollClientData, UnenrollClientErrors, UnenrollClientResponses, UpdateCohortData, UpdateCohortErrors, UpdateCohortResponses, UpdateContactData, UpdateContactResponses, UpdateMedicationData, UpdateMedicationErrors, UpdateMedicationNestedData, UpdateMedicationNestedErrors, UpdateMedicationNestedResponses, UpdateMedicationResponses, UpdateOrganizationData, UpdateOrganizationErrors, UpdateOrganizationResponses, UpdateParticipantData, UpdateParticipantErrors, UpdateParticipantResponses, UpdateProfile2Data, UpdateProfile2Errors, UpdateProfile2Responses, UpdateProfileData, UpdateProfileResponses, UpdateSiteData, UpdateSiteErrors, UpdateSiteResponses, UpdateTrialData, UpdateTrialErrors, UpdateTrialParticipantData, UpdateTrialParticipantErrors, UpdateTrialParticipantResponses, UpdateTrialResponses, UpdateTrialSetupRequestData, UpdateTrialSetupRequestErrors, UpdateTrialSetupRequestResponses, UpsertSettingsData, UpsertSettingsResponses, ValidateAssignmentsData, ValidateAssignmentsErrors, ValidateAssignmentsResponses, VerifyChain2Data, VerifyChain2Errors, VerifyChain2Responses, VerifyChainData, VerifyChainErrors, VerifyChainResponses, VerifyTokenData, VerifyTokenErrors, VerifyTokenResponses, WithdrawEnrollmentData, WithdrawEnrollmentErrors, WithdrawEnrollmentResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * List audit logs with pagination and optional filters.
 *
 * Supports filtering by action, resource type, resource ID, severity,
 * date range, and user search. Filters accept comma-separated values
 * for multi-value matching. Combined with standard `ListParams` pagination.
 */
export const listAuditLogs = <ThrowOnError extends boolean = false>(options?: Options<ListAuditLogsData, ThrowOnError>) => (options?.client ?? client).get<ListAuditLogsResponses, ListAuditLogsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/audit-logs',
    ...options
});

/**
 * Export audit logs as a JSON file download.
 *
 * Applies the same filters as `list_audit_logs` but returns ALL matching
 * rows (no pagination) as a downloadable JSON attachment.
 */
export const exportAuditLogs = <ThrowOnError extends boolean = false>(options?: Options<ExportAuditLogsData, ThrowOnError>) => (options?.client ?? client).get<ExportAuditLogsResponses, ExportAuditLogsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/audit-logs/export',
    ...options
});

/**
 * Get available filter metadata for audit log UI controls.
 *
 * Returns lists of valid actions, resource types, and severity levels
 * that can be used in filter dropdowns.
 */
export const getMetadata = <ThrowOnError extends boolean = false>(options?: Options<GetMetadataData, ThrowOnError>) => (options?.client ?? client).get<GetMetadataResponses, GetMetadataErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/audit-logs/metadata',
    ...options
});

/**
 * Verify the integrity of the entire audit hash chain.
 *
 * Loads all audit log entries and verifies each entry's HMAC signature
 * plus the hash chain linking consecutive entries.
 */
export const verifyChain = <ThrowOnError extends boolean = false>(options?: Options<VerifyChainData, ThrowOnError>) => (options?.client ?? client).post<VerifyChainResponses, VerifyChainErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/audit-logs/verify',
    ...options
});

/**
 * Export audit logs as CSV or JSON.
 */
export const exportAuditLogs2 = <ThrowOnError extends boolean = false>(options: Options<ExportAuditLogs2Data, ThrowOnError>) => (options.client ?? client).post<ExportAuditLogs2Responses, ExportAuditLogs2Errors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/exports/audit-logs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Export users as CSV or JSON.
 */
export const exportUsers = <ThrowOnError extends boolean = false>(options: Options<ExportUsersData, ThrowOnError>) => (options.client ?? client).post<ExportUsersResponses, ExportUsersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/exports/users',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List all invitations (paginated).
 *
 * Returns active (non-archived) invitations sorted by `created_at` descending.
 * Supports text search on email and status filter (`pending`, `accepted`, `expired`).
 */
export const listInvitations = <ThrowOnError extends boolean = false>(options?: Options<ListInvitationsData, ThrowOnError>) => (options?.client ?? client).get<ListInvitationsResponses, ListInvitationsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/invitations',
    ...options
});

/**
 * Send a single invitation.
 *
 * Creates an invitation record for the given email address. The email must not
 * already be registered as a user or have an active (non-archived, non-expired)
 * invitation. Returns a message on success.
 */
export const sendInvitation = <ThrowOnError extends boolean = false>(options: Options<SendInvitationData, ThrowOnError>) => (options.client ?? client).post<SendInvitationResponses, SendInvitationErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/invitations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send bulk invitations.
 *
 * Attempts to create an invitation for each email address. Emails that are
 * already registered or already have active invitations are skipped and
 * reported in the `failed` map.
 */
export const bulkSend = <ThrowOnError extends boolean = false>(options: Options<BulkSendData, ThrowOnError>) => (options.client ?? client).post<BulkSendResponses, BulkSendErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/invitations/bulk',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Validate emails for bulk invitation.
 *
 * For each email, checks format validity, whether it is already registered,
 * and whether an active invitation already exists. Returns categorized results.
 */
export const bulkValidate = <ThrowOnError extends boolean = false>(options: Options<BulkValidateData, ThrowOnError>) => (options.client ?? client).post<BulkValidateResponses, BulkValidateErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/invitations/bulk/validate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke (archive) an invitation.
 *
 * Soft-deletes the invitation by setting `archived_at` and `archived_by_id`.
 * Returns a message on success.
 */
export const revokeInvitation = <ThrowOnError extends boolean = false>(options: Options<RevokeInvitationData, ThrowOnError>) => (options.client ?? client).delete<RevokeInvitationResponses, RevokeInvitationErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/invitations/{id}',
    ...options
});

/**
 * List all users (admin only) — with organization count enrichment.
 */
export const listUsers = <ThrowOnError extends boolean = false>(options?: Options<ListUsersData, ThrowOnError>) => (options?.client ?? client).get<ListUsersResponses, ListUsersErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users',
    ...options
});

/**
 * Delete or archive a user (admin only).
 *
 * If the user owns organizations with participants, the user is archived
 * instead of deleted to preserve referential integrity.
 */
export const deleteUser = <ThrowOnError extends boolean = false>(options: Options<DeleteUserData, ThrowOnError>) => (options.client ?? client).delete<DeleteUserResponses, DeleteUserErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}',
    ...options
});

/**
 * Activate a user (admin only) — with enrichment.
 */
export const activateUser = <ThrowOnError extends boolean = false>(options: Options<ActivateUserData, ThrowOnError>) => (options.client ?? client).put<ActivateUserResponses, ActivateUserErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/activate',
    ...options
});

/**
 * Deactivate a user (admin only) — with enrichment.
 */
export const deactivateUser = <ThrowOnError extends boolean = false>(options: Options<DeactivateUserData, ThrowOnError>) => (options.client ?? client).put<DeactivateUserResponses, DeactivateUserErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/deactivate',
    ...options
});

/**
 * Get user activity statistics (admin only) — with organization enrichment.
 */
export const getUserStatistics = <ThrowOnError extends boolean = false>(options: Options<GetUserStatisticsData, ThrowOnError>) => (options.client ?? client).get<GetUserStatisticsResponses, GetUserStatisticsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_id}/statistics',
    ...options
});

/**
 * List audit logs with pagination and optional filters.
 *
 * Supports filtering by action, resource type, resource ID, severity,
 * date range, and user search. Filters accept comma-separated values
 * for multi-value matching. Combined with standard `ListParams` pagination.
 */
export const listAuditLogs2 = <ThrowOnError extends boolean = false>(options?: Options<ListAuditLogs2Data, ThrowOnError>) => (options?.client ?? client).get<ListAuditLogs2Responses, ListAuditLogs2Errors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/audit-logs',
    ...options
});

/**
 * Export audit logs as a JSON file download.
 *
 * Applies the same filters as `list_audit_logs` but returns ALL matching
 * rows (no pagination) as a downloadable JSON attachment.
 */
export const exportAuditLogs3 = <ThrowOnError extends boolean = false>(options?: Options<ExportAuditLogs3Data, ThrowOnError>) => (options?.client ?? client).get<ExportAuditLogs3Responses, ExportAuditLogs3Errors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/audit-logs/export',
    ...options
});

/**
 * Get available filter metadata for audit log UI controls.
 *
 * Returns lists of valid actions, resource types, and severity levels
 * that can be used in filter dropdowns.
 */
export const getMetadata2 = <ThrowOnError extends boolean = false>(options?: Options<GetMetadata2Data, ThrowOnError>) => (options?.client ?? client).get<GetMetadata2Responses, GetMetadata2Errors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/audit-logs/metadata',
    ...options
});

/**
 * Verify the integrity of the entire audit hash chain.
 *
 * Loads all audit log entries and verifies each entry's HMAC signature
 * plus the hash chain linking consecutive entries.
 */
export const verifyChain2 = <ThrowOnError extends boolean = false>(options?: Options<VerifyChain2Data, ThrowOnError>) => (options?.client ?? client).post<VerifyChain2Responses, VerifyChain2Errors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/audit-logs/verify',
    ...options
});

/**
 * Accept an invitation and create a new user account.
 */
export const acceptInvitation = <ThrowOnError extends boolean = false>(options: Options<AcceptInvitationData, ThrowOnError>) => (options.client ?? client).post<AcceptInvitationResponses, AcceptInvitationErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/auth/accept-invitation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Authenticate and receive a JWT token.
 */
export const login = <ThrowOnError extends boolean = false>(options: Options<LoginData, ThrowOnError>) => (options.client ?? client).post<LoginResponses, LoginErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/auth/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Complete two-factor authentication login.
 */
export const login2Fa = <ThrowOnError extends boolean = false>(options: Options<Login2FaData, ThrowOnError>) => (options.client ?? client).post<Login2FaResponses, Login2FaErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/auth/login/2fa',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Log out the current user by blacklisting their token.
 */
export const logout = <ThrowOnError extends boolean = false>(options?: Options<LogoutData, ThrowOnError>) => (options?.client ?? client).post<LogoutResponses, LogoutErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/logout',
    ...options
});

/**
 * Get the current authenticated user's profile.
 */
export const getProfile = <ThrowOnError extends boolean = false>(options?: Options<GetProfileData, ThrowOnError>) => (options?.client ?? client).get<GetProfileResponses, GetProfileErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/me',
    ...options
});

/**
 * Complete passkey authentication and issue a JWT.
 */
export const authFinish = <ThrowOnError extends boolean = false>(options: Options<AuthFinishData, ThrowOnError>) => (options.client ?? client).post<AuthFinishResponses, AuthFinishErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/auth/passkey/finish',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start passkey authentication.
 *
 * Accepts the user's email. If the user has registered passkeys, returns
 * `WebAuthn` request options with `allowCredentials` populated so that
 * password managers can match the credential. If the user has no passkeys
 * (or the email is unknown), returns `{ has_passkeys: false }` without
 * revealing whether the email exists.
 */
export const authStart = <ThrowOnError extends boolean = false>(options: Options<AuthStartData, ThrowOnError>) => (options.client ?? client).post<AuthStartResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/auth/passkey/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Request a password reset email.
 *
 * Always returns success to prevent email enumeration.
 */
export const passwordRecovery = <ThrowOnError extends boolean = false>(options: Options<PasswordRecoveryData, ThrowOnError>) => (options.client ?? client).post<PasswordRecoveryResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/auth/password-recovery',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reset password using a token received via email.
 */
export const passwordReset = <ThrowOnError extends boolean = false>(options: Options<PasswordResetData, ThrowOnError>) => (options.client ?? client).post<PasswordResetResponses, PasswordResetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/auth/password-reset',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create a dispenser assignment for the enrolled participant.
 *
 * Links a dispenser (by serial number) to a medication slot belonging to the
 * authenticated participant. Creates the dispenser record if it doesn't exist.
 * Idempotent: returns 200 if the exact assignment already exists, 201 if new.
 */
export const createAssignment = <ThrowOnError extends boolean = false>(options: Options<CreateAssignmentData, ThrowOnError>) => (options.client ?? client).post<CreateAssignmentResponses, CreateAssignmentErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/client/assignments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Pre-flight validate a batch of dispenser assignments.
 *
 * Checks whether each assignment would succeed without creating anything.
 * Returns one result per input item.
 */
export const validateAssignments = <ThrowOnError extends boolean = false>(options: Options<ValidateAssignmentsData, ThrowOnError>) => (options.client ?? client).post<ValidateAssignmentsResponses, ValidateAssignmentsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/client/assignments/validate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Unassign a dispenser from its current medication slot.
 *
 * Marks the active assignment for the given dispenser as inactive and records
 * the unassignment timestamp and optional reason. Idempotent.
 */
export const unassign = <ThrowOnError extends boolean = false>(options: Options<UnassignData, ThrowOnError>) => (options.client ?? client).post<UnassignResponses, UnassignErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/client/assignments/{dispenser_serial}/unassign',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Enroll a device using an enrollment token.
 *
 * Validates the enrollment token against the participant table, creates or
 * activates the enrollment, and returns a JWT access token.
 */
export const enroll = <ThrowOnError extends boolean = false>(options: Options<EnrollData, ThrowOnError>) => (options.client ?? client).post<EnrollResponses, EnrollErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/client/enroll',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Enroll a device using a human-friendly passphrase.
 *
 * Normalizes the input (lowercase, trim, replace spaces with hyphens),
 * resolves the participant by passphrase, then delegates to the standard
 * enrollment flow.
 */
export const enrollPassphrase = <ThrowOnError extends boolean = false>(options: Options<EnrollPassphraseData, ThrowOnError>) => (options.client ?? client).post<EnrollPassphraseResponses, EnrollPassphraseErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/client/enroll-passphrase',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Device heartbeat — records app status, device health, and connection logs.
 *
 * Called periodically by the Hermes mobile app. Stores per-device status
 * snapshots, BLE connection logs (deduplicated by client log ID), and
 * returns client configuration from trial settings.
 */
export const heartbeat = <ThrowOnError extends boolean = false>(options: Options<HeartbeatData, ThrowOnError>) => (options.client ?? client).post<HeartbeatResponses, HeartbeatErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/client/heartbeat',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get the authenticated enrollment's information.
 *
 * Returns participant and enrollment details along with active dispenser
 * assignments.
 */
export const getMe = <ThrowOnError extends boolean = false>(options?: Options<GetMeData, ThrowOnError>) => (options?.client ?? client).get<GetMeResponses, GetMeErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/client/me',
    ...options
});

/**
 * Get medication slots for the authenticated participant.
 *
 * Returns the participant's medication slots along with their medication
 * requirements and any current dispenser assignments.
 */
export const getMedicationSlots = <ThrowOnError extends boolean = false>(options?: Options<GetMedicationSlotsData, ThrowOnError>) => (options?.client ?? client).get<GetMedicationSlotsResponses, GetMedicationSlotsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/client/medication-slots',
    ...options
});

/**
 * Register a push notification token for this enrollment.
 *
 * Upserts: if a registration exists for this enrollment, updates the token
 * and resets failures. Otherwise creates a new registration.
 */
export const registerPushToken = <ThrowOnError extends boolean = false>(options: Options<RegisterPushTokenData, ThrowOnError>) => (options.client ?? client).post<RegisterPushTokenResponses, RegisterPushTokenErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/client/push-token',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Refresh a client access token using an enrollment token.
 *
 * Same flow as enrollment but requires an existing active enrollment.
 */
export const refresh = <ThrowOnError extends boolean = false>(options: Options<RefreshData, ThrowOnError>) => (options.client ?? client).post<RefreshResponses, RefreshErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/client/refresh',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Submit a battery reading for a dispenser.
 *
 * Records a single battery voltage and percentage measurement.
 */
export const syncBattery = <ThrowOnError extends boolean = false>(options: Options<SyncBatteryData, ThrowOnError>) => (options.client ?? client).post<SyncBatteryResponses, SyncBatteryErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/client/sync/battery',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bulk sync events and battery readings for multiple dispensers.
 *
 * Accepts a map of dispenser serial numbers to their sync payloads, allowing
 * the client to batch all pending data in a single request.
 */
export const syncBulk = <ThrowOnError extends boolean = false>(options: Options<SyncBulkData, ThrowOnError>) => (options.client ?? client).post<SyncBulkResponses, SyncBulkErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/client/sync/bulk',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Submit dispenser events for processing.
 *
 * Receives hex-encoded dispenser events and processes them. Duplicate events
 * are detected and skipped.
 */
export const syncEvents = <ThrowOnError extends boolean = false>(options: Options<SyncEventsData, ThrowOnError>) => (options.client ?? client).post<SyncEventsResponses, SyncEventsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/client/sync/events',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Unenroll (withdraw) the authenticated participant.
 *
 * Sets enrollment status to `WITHDRAWN` and deactivates all active
 * assignments. Idempotent: returns 409 if the enrollment is already
 * in a terminal state.
 */
export const unenrollClient = <ThrowOnError extends boolean = false>(options: Options<UnenrollClientData, ThrowOnError>) => (options.client ?? client).post<UnenrollClientResponses, UnenrollClientErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/client/unenroll',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Smart delete a cohort.
 *
 * Calculates deletion strategy based on resource state:
 * - **No participants** → hard delete (permanent removal)
 * - **Has participants** → archive (soft delete)
 * - **Already archived** → error (must unarchive first)
 *
 * Requires system admin permission.
 */
export const deleteCohort = <ThrowOnError extends boolean = false>(options: Options<DeleteCohortData, ThrowOnError>) => (options.client ?? client).delete<DeleteCohortResponses, DeleteCohortErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/cohorts/{id}',
    ...options
});

/**
 * Get a cohort by ID.
 */
export const getCohort = <ThrowOnError extends boolean = false>(options: Options<GetCohortData, ThrowOnError>) => (options.client ?? client).get<GetCohortResponses, GetCohortErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/cohorts/{id}',
    ...options
});

/**
 * Update a cohort (PUT).
 *
 * When the name changes, the slug is regenerated automatically.
 * Parent trial must not be archived.
 */
export const updateCohort = <ThrowOnError extends boolean = false>(options: Options<UpdateCohortData, ThrowOnError>) => (options.client ?? client).put<UpdateCohortResponses, UpdateCohortErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/cohorts/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Unarchive (restore) an archived cohort. System admin only.
 *
 * Checks that the parent trial is not archived before restoring.
 */
export const unarchiveCohort = <ThrowOnError extends boolean = false>(options: Options<UnarchiveCohortData, ThrowOnError>) => (options.client ?? client).post<UnarchiveCohortResponses, UnarchiveCohortErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/cohorts/{id}/unarchive',
    ...options
});

/**
 * Generate a CSRF token.
 *
 * Returns an HMAC-signed CSRF token in the format `{timestamp}:{random_hex}:{signature}`.
 * Returns an HMAC-signed CSRF token.
 *
 * - `timestamp` — Unix epoch seconds
 * - `random_hex` — 16 random bytes, hex-encoded (32 chars)
 * - `signature` — HMAC-SHA256 of `{timestamp}:{random_hex}`, hex-encoded (64 chars)
 */
export const csrfToken = <ThrowOnError extends boolean = false>(options?: Options<CsrfTokenData, ThrowOnError>) => (options?.client ?? client).get<CsrfTokenResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/csrf-token',
    ...options
});

/**
 * List dispensers (paginated, filterable) with enriched relations.
 *
 * Returns dispensers with battery status, connectivity, assignment info,
 * sync status, and resource state.
 */
export const listDispensers = <ThrowOnError extends boolean = false>(options?: Options<ListDispensersData, ThrowOnError>) => (options?.client ?? client).get<ListDispensersResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/dispensers',
    ...options
});

/**
 * Alias endpoint: `/api/v1/dispensers/with-relations`.
 *
 * Delegates to `list_dispensers` for Python frontend compatibility.
 */
export const listDispensersAlias = <ThrowOnError extends boolean = false>(options?: Options<ListDispensersAliasData, ThrowOnError>) => (options?.client ?? client).get<ListDispensersAliasResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/dispensers/with-relations',
    ...options
});

/**
 * Get assignment timeline for a dispenser.
 *
 * Returns enriched timeline events for all assignments (active and historical).
 */
export const assignmentTimeline = <ThrowOnError extends boolean = false>(options: Options<AssignmentTimelineData, ThrowOnError>) => (options.client ?? client).get<AssignmentTimelineResponses, AssignmentTimelineErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/dispensers/{slug}/assignment-timeline',
    ...options
});

/**
 * Get dispenser audit events (paginated) with severity and description.
 *
 * Returns enriched dispenser events for a specific dispenser.
 */
export const auditEvents = <ThrowOnError extends boolean = false>(options: Options<AuditEventsData, ThrowOnError>) => (options.client ?? client).get<AuditEventsResponses, AuditEventsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/dispensers/{slug}/audit-events',
    ...options
});

/**
 * Get battery trend with summary and trend direction.
 *
 * Returns the most recent battery readings with computed summary statistics
 * and trend direction (improving/stable/declining).
 */
export const batteryTrend = <ThrowOnError extends boolean = false>(options: Options<BatteryTrendData, ThrowOnError>) => (options.client ?? client).get<BatteryTrendResponses, BatteryTrendErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/dispensers/{slug}/battery-trend',
    ...options
});

/**
 * List connection logs for a dispenser.
 *
 * Returns paginated BLE connection attempt logs with search and filters.
 */
export const connectionLogs = <ThrowOnError extends boolean = false>(options: Options<ConnectionLogsData, ThrowOnError>) => (options.client ?? client).get<ConnectionLogsResponses, ConnectionLogsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/dispensers/{slug}/connection-logs',
    ...options
});

/**
 * Get detailed dispenser info by slug.
 *
 * Returns the dispenser with enriched battery, connectivity, assignment, and
 * resource state information.
 */
export const getDetailed = <ThrowOnError extends boolean = false>(options: Options<GetDetailedData, ThrowOnError>) => (options.client ?? client).get<GetDetailedResponses, GetDetailedErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/dispensers/{slug}/detailed',
    ...options
});

/**
 * Get a maps authentication token.
 *
 * Returns a credential the frontend uses with the Azure Maps SDK.
 * Requires an authenticated user session.
 */
export const getMapsToken = <ThrowOnError extends boolean = false>(options?: Options<GetMapsTokenData, ThrowOnError>) => (options?.client ?? client).get<GetMapsTokenResponses, GetMapsTokenErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/maps/token',
    ...options
});

/**
 * Smart delete a medication requirement.
 *
 * Calculates deletion strategy based on resource state:
 * - **No medication slots** -> hard delete (permanent removal)
 * - **Has slots** -> archive (soft delete)
 * - **Already archived** -> error (must unarchive first)
 *
 * Requires system admin permission.
 */
export const deleteMedication = <ThrowOnError extends boolean = false>(options: Options<DeleteMedicationData, ThrowOnError>) => (options.client ?? client).delete<DeleteMedicationResponses, DeleteMedicationErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/medications/{id}',
    ...options
});

/**
 * Get a medication requirement by ID.
 */
export const getMedication = <ThrowOnError extends boolean = false>(options: Options<GetMedicationData, ThrowOnError>) => (options.client ?? client).get<GetMedicationResponses, GetMedicationErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/medications/{id}',
    ...options
});

/**
 * Update a medication requirement (PUT).
 *
 * Both `dose_mg` and `pills_per_day` are optional; only provided fields are updated.
 * Parent cohort must not be archived.
 */
export const updateMedication = <ThrowOnError extends boolean = false>(options: Options<UpdateMedicationData, ThrowOnError>) => (options.client ?? client).put<UpdateMedicationResponses, UpdateMedicationErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/medications/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List current user's notifications.
 */
export const listNotifications = <ThrowOnError extends boolean = false>(options?: Options<ListNotificationsData, ThrowOnError>) => (options?.client ?? client).get<ListNotificationsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/notifications',
    ...options
});

/**
 * Get unread notification count (lightweight for polling).
 */
export const getUnreadCount = <ThrowOnError extends boolean = false>(options?: Options<GetUnreadCountData, ThrowOnError>) => (options?.client ?? client).get<GetUnreadCountResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/notifications/count',
    ...options
});

/**
 * Mark all notifications as read.
 */
export const markAllAsRead = <ThrowOnError extends boolean = false>(options?: Options<MarkAllAsReadData, ThrowOnError>) => (options?.client ?? client).post<MarkAllAsReadResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/notifications/read-all',
    ...options
});

/**
 * Mark a single notification as read.
 */
export const markAsRead = <ThrowOnError extends boolean = false>(options: Options<MarkAsReadData, ThrowOnError>) => (options.client ?? client).post<MarkAsReadResponses, unknown, ThrowOnError>({ url: '/api/v1/notifications/{id}/read', ...options });

/**
 * List organizations the user has access to (paginated).
 *
 * Returns organizations with pagination, sorting, and search.
 * Supports filtering by status: "active" (default), "archived", or "all".
 *
 * **Permission filtering:**
 * - System admins/viewers see all organizations
 * - Regular users see only organizations they have explicit permissions on
 */
export const listOrganizations = <ThrowOnError extends boolean = false>(options?: Options<ListOrganizationsData, ThrowOnError>) => (options?.client ?? client).get<ListOrganizationsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations',
    ...options
});

/**
 * Create a new organization.
 *
 * Requires system admin permission. Slug is auto-generated from the name.
 */
export const createOrganization = <ThrowOnError extends boolean = false>(options: Options<CreateOrganizationData, ThrowOnError>) => (options.client ?? client).post<CreateOrganizationResponses, CreateOrganizationErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get organization by slug.
 */
export const getOrganizationBySlug = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationBySlugData, ThrowOnError>) => (options.client ?? client).get<GetOrganizationBySlugResponses, GetOrganizationBySlugErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/slug/{slug}',
    ...options
});

/**
 * Smart delete an organization.
 *
 * Calculates deletion strategy based on resource state:
 * - **No trials** → hard delete (permanent removal)
 * - **Has trials** → archive (soft delete)
 * - **Already archived** → error (must unarchive first)
 *
 * Requires system admin permission.
 */
export const deleteOrganization = <ThrowOnError extends boolean = false>(options: Options<DeleteOrganizationData, ThrowOnError>) => (options.client ?? client).delete<DeleteOrganizationResponses, DeleteOrganizationErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/{id}',
    ...options
});

/**
 * Get organization by ID.
 */
export const getOrganization = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationData, ThrowOnError>) => (options.client ?? client).get<GetOrganizationResponses, GetOrganizationErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/{id}',
    ...options
});

/**
 * Update an organization.
 *
 * When the name changes, the slug is regenerated automatically.
 * Name uniqueness is checked (case-insensitive, excluding self).
 */
export const updateOrganization = <ThrowOnError extends boolean = false>(options: Options<UpdateOrganizationData, ThrowOnError>) => (options.client ?? client).put<UpdateOrganizationResponses, UpdateOrganizationErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get organization dashboard statistics.
 *
 * Returns the full organization response enriched with participant,
 * dispenser, and activity statistics. Matches Python's `OrganizationDashboard`.
 */
export const getOrganizationDashboard = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationDashboardData, ThrowOnError>) => (options.client ?? client).get<GetOrganizationDashboardResponses, GetOrganizationDashboardErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/{id}/dashboard',
    ...options
});

/**
 * Unarchive (restore) an archived organization.
 *
 * Requires system admin permission. Returns an error if not archived.
 */
export const unarchiveOrganization = <ThrowOnError extends boolean = false>(options: Options<UnarchiveOrganizationData, ThrowOnError>) => (options.client ?? client).post<UnarchiveOrganizationResponses, UnarchiveOrganizationErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/{id}/unarchive',
    ...options
});

/**
 * List trial setup requests for an organization (paginated).
 *
 * Returns setup requests with pagination, sorting, and search. Filters by
 * status when `?status=` is provided; defaults to showing all non-archived.
 */
export const listTrialSetupRequests = <ThrowOnError extends boolean = false>(options: Options<ListTrialSetupRequestsData, ThrowOnError>) => (options.client ?? client).get<ListTrialSetupRequestsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/{org_id}/trial-setup-requests',
    ...options
});

/**
 * Create a new trial setup request.
 *
 * Auto-generates a `public_token` (UUID) and slug from the name.
 * Status starts as "draft".
 */
export const createTrialSetupRequest = <ThrowOnError extends boolean = false>(options: Options<CreateTrialSetupRequestData, ThrowOnError>) => (options.client ?? client).post<CreateTrialSetupRequestResponses, CreateTrialSetupRequestErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/{org_id}/trial-setup-requests',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete or archive a trial setup request. Admin only.
 *
 * Drafts are hard-deleted; all other statuses are archived (soft-deleted).
 * Returns 200 with a deletion response body in both cases (matching Python).
 */
export const deleteTrialSetupRequest = <ThrowOnError extends boolean = false>(options: Options<DeleteTrialSetupRequestData, ThrowOnError>) => (options.client ?? client).delete<DeleteTrialSetupRequestResponses, DeleteTrialSetupRequestErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/{org_id}/trial-setup-requests/{id}',
    ...options
});

/**
 * Get a trial setup request by ID.
 */
export const getTrialSetupRequest = <ThrowOnError extends boolean = false>(options: Options<GetTrialSetupRequestData, ThrowOnError>) => (options.client ?? client).get<GetTrialSetupRequestResponses, GetTrialSetupRequestErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/{org_id}/trial-setup-requests/{id}',
    ...options
});

/**
 * Update a draft trial setup request.
 *
 * Only requests in DRAFT status can be updated. When the name changes,
 * the slug is regenerated automatically.
 */
export const updateTrialSetupRequest = <ThrowOnError extends boolean = false>(options: Options<UpdateTrialSetupRequestData, ThrowOnError>) => (options.client ?? client).put<UpdateTrialSetupRequestResponses, UpdateTrialSetupRequestErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/{org_id}/trial-setup-requests/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Approve a submitted trial setup request. Admin only.
 *
 * Validates form data, then atomically generates a complete trial (with
 * cohorts, sites, medications, participants, and enrollments) from the
 * submission. Status transitions from SUBMITTED to APPROVED.
 */
export const approveTrialSetupRequest = <ThrowOnError extends boolean = false>(options: Options<ApproveTrialSetupRequestData, ThrowOnError>) => (options.client ?? client).post<ApproveTrialSetupRequestResponses, ApproveTrialSetupRequestErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/{org_id}/trial-setup-requests/{id}/approve',
    ...options
});

/**
 * Reject a submitted trial setup request. Admin only.
 *
 * Transitions status from SUBMITTED to REJECTED with review notes.
 */
export const rejectTrialSetupRequest = <ThrowOnError extends boolean = false>(options: Options<RejectTrialSetupRequestData, ThrowOnError>) => (options.client ?? client).post<RejectTrialSetupRequestResponses, RejectTrialSetupRequestErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/{org_id}/trial-setup-requests/{id}/reject',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Submit a trial setup request for review.
 *
 * Transitions status from DRAFT to SUBMITTED.
 */
export const submitTrialSetupRequest = <ThrowOnError extends boolean = false>(options: Options<SubmitTrialSetupRequestData, ThrowOnError>) => (options.client ?? client).post<SubmitTrialSetupRequestResponses, SubmitTrialSetupRequestErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/{org_id}/trial-setup-requests/{id}/submit',
    ...options
});

/**
 * List trials for an organization (paginated).
 *
 * Returns trials with pagination, sorting, and search. Filters by active
 * status by default; use `?status=all` or `?status=archived` to change.
 */
export const listTrials = <ThrowOnError extends boolean = false>(options: Options<ListTrialsData, ThrowOnError>) => (options.client ?? client).get<ListTrialsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/{org_id}/trials',
    ...options
});

/**
 * Create a new trial within an organization.
 */
export const createTrial = <ThrowOnError extends boolean = false>(options: Options<CreateTrialData, ThrowOnError>) => (options.client ?? client).post<CreateTrialResponses, CreateTrialErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/{org_id}/trials',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Smart delete a participant. System admin only.
 *
 * Uses resource state to determine strategy:
 * - **Delete**: Hard-delete if no enrollment or assignments.
 * - **Archive**: Soft-delete if has enrollment or active assignments.
 * - **Blocked**: Error if already archived.
 */
export const deleteParticipant = <ThrowOnError extends boolean = false>(options: Options<DeleteParticipantData, ThrowOnError>) => (options.client ?? client).delete<DeleteParticipantResponses, DeleteParticipantErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participants/{id}',
    ...options
});

/**
 * Get a participant by ID.
 */
export const getParticipant = <ThrowOnError extends boolean = false>(options: Options<GetParticipantData, ThrowOnError>) => (options.client ?? client).get<GetParticipantResponses, GetParticipantErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participants/{id}',
    ...options
});

/**
 * Update a participant.
 *
 * If `cohort_id` or `site_id` changes, verifies the new value belongs to the same trial.
 * If `participant_id` changes, validates format and uniqueness within the target cohort.
 */
export const updateParticipant = <ThrowOnError extends boolean = false>(options: Options<UpdateParticipantData, ThrowOnError>) => (options.client ?? client).patch<UpdateParticipantResponses, UpdateParticipantErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participants/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get participant medication adherence data.
 *
 * Returns adherence data with daily breakdowns, data quality flags,
 * bottle events, and quality events for the specified date range.
 */
export const getParticipantAdherence = <ThrowOnError extends boolean = false>(options: Options<GetParticipantAdherenceData, ThrowOnError>) => (options.client ?? client).get<GetParticipantAdherenceResponses, GetParticipantAdherenceErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participants/{id}/adherence',
    ...options
});

/**
 * Complete an enrollment — mark as `COMPLETED` and deactivate assignments.
 *
 * Requires system admin. Returns 409 if already terminal.
 */
export const completeEnrollment = <ThrowOnError extends boolean = false>(options: Options<CompleteEnrollmentData, ThrowOnError>) => (options.client ?? client).post<CompleteEnrollmentResponses, CompleteEnrollmentErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participants/{id}/complete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send a push notification to a single participant.
 */
export const sendParticipantPush = <ThrowOnError extends boolean = false>(options: Options<SendParticipantPushData, ThrowOnError>) => (options.client ?? client).post<SendParticipantPushResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/participants/{id}/push',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reset a single participant's enrollment data. **Staging/development only.**
 *
 * Deletes the participant's enrollments, dispenser assignments, the dispensers
 * they used, and all derived events/telemetry, while preserving the participant,
 * their medication slots, cohort, site, and trial config. Lets the participant
 * re-enroll from scratch and frees their dispenser serials for reuse.
 *
 * This route is not mounted in production; the handler also rejects production
 * as a backstop.
 */
export const resetParticipantEnrollment = <ThrowOnError extends boolean = false>(options: Options<ResetParticipantEnrollmentData, ThrowOnError>) => (options.client ?? client).post<ResetParticipantEnrollmentResponses, ResetParticipantEnrollmentErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participants/{id}/reset-enrollment',
    ...options
});

/**
 * Unarchive (restore) an archived participant. System admin only.
 */
export const unarchiveParticipant = <ThrowOnError extends boolean = false>(options: Options<UnarchiveParticipantData, ThrowOnError>) => (options.client ?? client).post<UnarchiveParticipantResponses, UnarchiveParticipantErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participants/{id}/unarchive',
    ...options
});

/**
 * Withdraw an enrollment — mark as `WITHDRAWN` and deactivate assignments.
 *
 * Requires system admin. Returns 409 if already terminal.
 */
export const withdrawEnrollment = <ThrowOnError extends boolean = false>(options: Options<WithdrawEnrollmentData, ThrowOnError>) => (options.client ?? client).post<WithdrawEnrollmentResponses, WithdrawEnrollmentErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/participants/{id}/withdraw',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke permissions from a user (admin only).
 *
 * Revokes one or more permissions in bulk. Permissions that do not exist
 * are silently ignored.
 */
export const revokePermissions = <ThrowOnError extends boolean = false>(options: Options<RevokePermissionsData, ThrowOnError>) => (options.client ?? client).delete<RevokePermissionsResponses, RevokePermissionsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/permissions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List all permissions (paginated, admin only).
 *
 * Returns a paginated list of all permission records in the system.
 */
export const listPermissions = <ThrowOnError extends boolean = false>(options?: Options<ListPermissionsData, ThrowOnError>) => (options?.client ?? client).get<ListPermissionsResponses, ListPermissionsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/permissions',
    ...options
});

/**
 * Grant permissions to a user (admin only).
 *
 * Grants one or more permissions in bulk. Permissions that already exist
 * are skipped and reported in the `already_exists` field.
 */
export const grantPermissions = <ThrowOnError extends boolean = false>(options: Options<GrantPermissionsData, ThrowOnError>) => (options.client ?? client).post<GrantPermissionsResponses, GrantPermissionsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/permissions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Check a user's permissions (admin only).
 *
 * Checks one or more permission checks for a user and returns
 * whether each is allowed.
 */
export const checkPermissions = <ThrowOnError extends boolean = false>(options: Options<CheckPermissionsData, ThrowOnError>) => (options.client ?? client).post<CheckPermissionsResponses, CheckPermissionsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/permissions/check',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a user's permission summary (admin only).
 *
 * Returns all permissions for a specific user plus whether they are a system admin.
 */
export const getUserPermissions = <ThrowOnError extends boolean = false>(options: Options<GetUserPermissionsData, ThrowOnError>) => (options.client ?? client).get<GetUserPermissionsResponses, GetUserPermissionsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/permissions/users/{user_id}',
    ...options
});

/**
 * Get accessible resources for a user (admin only).
 *
 * Returns all resource IDs a user can access for a given resource type.
 */
export const getAccessibleResources = <ThrowOnError extends boolean = false>(options: Options<GetAccessibleResourcesData, ThrowOnError>) => (options.client ?? client).get<GetAccessibleResourcesResponses, GetAccessibleResourcesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/permissions/users/{user_id}/accessible-resources',
    ...options
});

/**
 * Exchange an email verification token for an access JWT.
 *
 * Decodes the 24-hour email verification JWT, looks up the submission,
 * and issues a 1-hour access token for form editing.
 */
export const verifyToken = <ThrowOnError extends boolean = false>(options: Options<VerifyTokenData, ThrowOnError>) => (options.client ?? client).get<VerifyTokenResponses, VerifyTokenErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/public/trial-setup/verify-token',
    ...options
});

/**
 * Get public submission info by public token.
 *
 * Returns basic submission details. If a valid access JWT is provided
 * in the Authorization header, the response includes full form data and
 * timestamps. Without authentication, form data is empty and a guidance
 * message is included.
 */
export const getSubmission = <ThrowOnError extends boolean = false>(options: Options<GetSubmissionData, ThrowOnError>) => (options.client ?? client).get<GetSubmissionResponses, GetSubmissionErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/public/trial-setup/{public_token}',
    ...options
});

/**
 * Autosave form data for a submission.
 *
 * Requires a valid access JWT from the verify-token endpoint. Only
 * submissions in draft or rejected status can be autosaved.
 */
export const autosave = <ThrowOnError extends boolean = false>(options: Options<AutosaveData, ThrowOnError>) => (options.client ?? client).put<AutosaveResponses, AutosaveErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/public/trial-setup/{public_token}/autosave',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Request email verification for a submission.
 *
 * If the email is in the submission's allowed list, sends a verification
 * email with a 24-hour JWT link. Always returns success to prevent
 * email enumeration.
 */
export const requestVerification = <ThrowOnError extends boolean = false>(options: Options<RequestVerificationData, ThrowOnError>) => (options.client ?? client).post<RequestVerificationResponses, RequestVerificationErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/public/trial-setup/{public_token}/request-verification',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Submit a trial setup form for review.
 *
 * Requires a valid access JWT. Validates form completeness (trial name,
 * at least one cohort, at least one site), saves form data, and transitions
 * the submission to "submitted" status.
 */
export const submit = <ThrowOnError extends boolean = false>(options: Options<SubmitData, ThrowOnError>) => (options.client ?? client).put<SubmitResponses, SubmitErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/public/trial-setup/{public_token}/submit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Unarchive (restore) an archived site.
 *
 * Requires system admin permission. Checks parent trial is not archived.
 */
export const unarchiveSite = <ThrowOnError extends boolean = false>(options: Options<UnarchiveSiteData, ThrowOnError>) => (options.client ?? client).post<UnarchiveSiteResponses, UnarchiveSiteErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/sites/{id}/unarchive',
    ...options
});

/**
 * Get a trial by slug.
 */
export const getTrialBySlug = <ThrowOnError extends boolean = false>(options: Options<GetTrialBySlugData, ThrowOnError>) => (options.client ?? client).get<GetTrialBySlugResponses, GetTrialBySlugErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/trials/by-slug/{slug}',
    ...options
});

/**
 * Get dispenser by trial slug and serial number.
 *
 * Looks up the trial by slug, finds the dispenser by serial number, and verifies
 * the dispenser has an active assignment to a participant enrolled in that trial.
 */
export const getByTrialAndSerial = <ThrowOnError extends boolean = false>(options: Options<GetByTrialAndSerialData, ThrowOnError>) => (options.client ?? client).get<GetByTrialAndSerialResponses, GetByTrialAndSerialErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/trials/by-slug/{trial_slug}/devices/{serial_number}',
    ...options
});

/**
 * Get participant by trial slug and human-readable participant ID.
 *
 * Looks up the trial by slug, then finds the participant by its display
 * `participant_id` field (e.g. "P001"), **not** the UUID.
 */
export const getParticipantBySlug = <ThrowOnError extends boolean = false>(options: Options<GetParticipantBySlugData, ThrowOnError>) => (options.client ?? client).get<GetParticipantBySlugResponses, GetParticipantBySlugErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/trials/by-slug/{trial_slug}/participants/{participant_display_id}',
    ...options
});

/**
 * Smart delete a trial.
 *
 * Calculates deletion strategy based on resource state:
 * - **No active participants** → hard delete (permanent removal)
 * - **Has active participants** → archive (soft delete)
 * - **Already archived** → error (must unarchive first)
 *
 * Requires system admin permission.
 */
export const deleteTrial = <ThrowOnError extends boolean = false>(options: Options<DeleteTrialData, ThrowOnError>) => (options.client ?? client).delete<DeleteTrialResponses, DeleteTrialErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/trials/{id}',
    ...options
});

/**
 * Get a trial by ID.
 */
export const getTrial = <ThrowOnError extends boolean = false>(options: Options<GetTrialData, ThrowOnError>) => (options.client ?? client).get<GetTrialResponses, GetTrialErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/trials/{id}',
    ...options
});

/**
 * Update a trial (PUT — full replacement of provided fields).
 */
export const updateTrial = <ThrowOnError extends boolean = false>(options: Options<UpdateTrialData, ThrowOnError>) => (options.client ?? client).put<UpdateTrialResponses, UpdateTrialErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/trials/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reset all enrollment data for a trial. **Staging/development only.**
 *
 * Deletes enrollments, dispenser assignments, the dispensers they used, and all
 * derived events/telemetry, while preserving participants, cohorts, sites,
 * medication requirements, and slots. Lets a trial be re-enrolled from scratch
 * and frees its dispenser serials for reuse (the dispenser→participant lock is
 * enforced through assignment history).
 *
 * This route is not mounted in production; the handler also rejects production
 * as a backstop.
 */
export const resetTrialEnrollment = <ThrowOnError extends boolean = false>(options: Options<ResetTrialEnrollmentData, ThrowOnError>) => (options.client ?? client).post<ResetTrialEnrollmentResponses, ResetTrialEnrollmentErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/trials/{id}/reset-enrollment',
    ...options
});

/**
 * Change trial operational status. System admin only.
 *
 * Only accepts `ACTIVE` or `ARCHIVED` as valid target statuses.
 */
export const changeTrialStatus = <ThrowOnError extends boolean = false>(options: Options<ChangeTrialStatusData, ThrowOnError>) => (options.client ?? client).put<ChangeTrialStatusResponses, ChangeTrialStatusErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/trials/{id}/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Unarchive a trial. System admin only.
 *
 * Checks that the parent organization is not archived before restoring.
 */
export const unarchiveTrial = <ThrowOnError extends boolean = false>(options: Options<UnarchiveTrialData, ThrowOnError>) => (options.client ?? client).post<UnarchiveTrialResponses, UnarchiveTrialErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/trials/{id}/unarchive',
    ...options
});

/**
 * Get population adherence for a trial.
 *
 * Returns aggregated adherence data across all participants in a trial,
 * with optional filtering by cohort/site, grouping, sorting, and pagination.
 */
export const getPopulationAdherence = <ThrowOnError extends boolean = false>(options: Options<GetPopulationAdherenceData, ThrowOnError>) => (options.client ?? client).get<GetPopulationAdherenceResponses, GetPopulationAdherenceErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/trials/{trial_id}/adherence/population',
    ...options
});

/**
 * List cohorts for a trial (paginated).
 *
 * Returns cohorts with pagination, sorting, and search. Filters by active
 * status by default; use `?status=all` or `?status=archived` to change.
 */
export const listCohorts = <ThrowOnError extends boolean = false>(options: Options<ListCohortsData, ThrowOnError>) => (options.client ?? client).get<ListCohortsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/trials/{trial_id}/cohorts',
    ...options
});

/**
 * Create a new cohort within a trial.
 *
 * Slug is auto-generated from the cohort name. Name must be unique within the trial.
 * Parent trial must not be archived.
 */
export const createCohort = <ThrowOnError extends boolean = false>(options: Options<CreateCohortData, ThrowOnError>) => (options.client ?? client).post<CreateCohortResponses, CreateCohortErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/trials/{trial_id}/cohorts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List medication requirements for a cohort (paginated).
 *
 * Returns medications with pagination, sorting, and search. Filters by active
 * status by default; use `?status=all` or `?status=archived` to change.
 */
export const listMedications = <ThrowOnError extends boolean = false>(options: Options<ListMedicationsData, ThrowOnError>) => (options.client ?? client).get<ListMedicationsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/trials/{trial_id}/cohorts/{cohort_id}/medications',
    ...options
});

/**
 * Create a new medication requirement within a cohort.
 *
 * The `dose_mg` is provided as a string and parsed to a decimal value.
 * Parent cohort and trial must not be archived.
 */
export const createMedication = <ThrowOnError extends boolean = false>(options: Options<CreateMedicationData, ThrowOnError>) => (options.client ?? client).post<CreateMedicationResponses, CreateMedicationErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/trials/{trial_id}/cohorts/{cohort_id}/medications',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Nested DELETE: `/trials/{trial_id}/cohorts/{cohort_id}/medications/{medication_id}`
 */
export const deleteMedicationNested = <ThrowOnError extends boolean = false>(options: Options<DeleteMedicationNestedData, ThrowOnError>) => (options.client ?? client).delete<DeleteMedicationNestedResponses, DeleteMedicationNestedErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/trials/{trial_id}/cohorts/{cohort_id}/medications/{medication_id}',
    ...options
});

/**
 * Nested GET: `/trials/{trial_id}/cohorts/{cohort_id}/medications/{medication_id}`
 */
export const getMedicationNested = <ThrowOnError extends boolean = false>(options: Options<GetMedicationNestedData, ThrowOnError>) => (options.client ?? client).get<GetMedicationNestedResponses, GetMedicationNestedErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/trials/{trial_id}/cohorts/{cohort_id}/medications/{medication_id}',
    ...options
});

/**
 * Nested PUT: `/trials/{trial_id}/cohorts/{cohort_id}/medications/{medication_id}`
 */
export const updateMedicationNested = <ThrowOnError extends boolean = false>(options: Options<UpdateMedicationNestedData, ThrowOnError>) => (options.client ?? client).put<UpdateMedicationNestedResponses, UpdateMedicationNestedErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/trials/{trial_id}/cohorts/{cohort_id}/medications/{medication_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List contacts for a trial.
 */
export const listContacts = <ThrowOnError extends boolean = false>(options: Options<ListContactsData, ThrowOnError>) => (options.client ?? client).get<ListContactsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/trials/{trial_id}/contacts',
    ...options
});

/**
 * Create a new contact for a trial.
 */
export const createContact = <ThrowOnError extends boolean = false>(options: Options<CreateContactData, ThrowOnError>) => (options.client ?? client).post<CreateContactResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/trials/{trial_id}/contacts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a trial contact.
 */
export const deleteContact = <ThrowOnError extends boolean = false>(options: Options<DeleteContactData, ThrowOnError>) => (options.client ?? client).delete<DeleteContactResponses, unknown, ThrowOnError>({ url: '/api/v1/trials/{trial_id}/contacts/{contact_id}', ...options });

/**
 * Update a trial contact.
 */
export const updateContact = <ThrowOnError extends boolean = false>(options: Options<UpdateContactData, ThrowOnError>) => (options.client ?? client).put<UpdateContactResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/trials/{trial_id}/contacts/{contact_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List notification deliveries for a trial.
 */
export const listDeliveries = <ThrowOnError extends boolean = false>(options: Options<ListDeliveriesData, ThrowOnError>) => (options.client ?? client).get<ListDeliveriesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/trials/{trial_id}/deliveries',
    ...options
});

/**
 * Export notification deliveries as CSV or JSON.
 */
export const exportDeliveries = <ThrowOnError extends boolean = false>(options: Options<ExportDeliveriesData, ThrowOnError>) => (options.client ?? client).post<ExportDeliveriesResponses, unknown, ThrowOnError>({
    url: '/api/v1/trials/{trial_id}/deliveries/export',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a single notification delivery.
 */
export const getDelivery = <ThrowOnError extends boolean = false>(options: Options<GetDeliveryData, ThrowOnError>) => (options.client ?? client).get<GetDeliveryResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/trials/{trial_id}/deliveries/{delivery_id}',
    ...options
});

/**
 * List attachments for a delivery (metadata only, no binary content).
 */
export const listDeliveryAttachments = <ThrowOnError extends boolean = false>(options: Options<ListDeliveryAttachmentsData, ThrowOnError>) => (options.client ?? client).get<ListDeliveryAttachmentsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/trials/{trial_id}/deliveries/{delivery_id}/attachments',
    ...options
});

/**
 * Download a delivery attachment.
 */
export const downloadAttachment = <ThrowOnError extends boolean = false>(options: Options<DownloadAttachmentData, ThrowOnError>) => (options.client ?? client).get<DownloadAttachmentResponses, unknown, ThrowOnError>({ url: '/api/v1/trials/{trial_id}/deliveries/{delivery_id}/attachments/{attachment_id}/download', ...options });

/**
 * Get the rendered HTML content of a delivery.
 *
 * Returns the archived email body as `text/html`.
 */
export const getDeliveryContent = <ThrowOnError extends boolean = false>(options: Options<GetDeliveryContentData, ThrowOnError>) => (options.client ?? client).get<GetDeliveryContentResponses, unknown, ThrowOnError>({
    responseType: 'text',
    url: '/api/v1/trials/{trial_id}/deliveries/{delivery_id}/content',
    ...options
});

/**
 * Get device health summary counts for a trial.
 */
export const deviceHealthSummary = <ThrowOnError extends boolean = false>(options: Options<DeviceHealthSummaryData, ThrowOnError>) => (options.client ?? client).get<DeviceHealthSummaryResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/trials/{trial_id}/device-health-summary',
    ...options
});

/**
 * List notification events for a trial.
 */
export const listEvents = <ThrowOnError extends boolean = false>(options: Options<ListEventsData, ThrowOnError>) => (options.client ?? client).get<ListEventsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/trials/{trial_id}/events',
    ...options
});

/**
 * Bulk acknowledge multiple events.
 */
export const bulkAcknowledge = <ThrowOnError extends boolean = false>(options: Options<BulkAcknowledgeData, ThrowOnError>) => (options.client ?? client).post<BulkAcknowledgeResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/trials/{trial_id}/events/bulk-acknowledge',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get event summary (counts by status, type, severity).
 */
export const getEventSummary = <ThrowOnError extends boolean = false>(options: Options<GetEventSummaryData, ThrowOnError>) => (options.client ?? client).get<GetEventSummaryResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/trials/{trial_id}/events/summary',
    ...options
});

/**
 * Get a single notification event.
 */
export const getEvent = <ThrowOnError extends boolean = false>(options: Options<GetEventData, ThrowOnError>) => (options.client ?? client).get<GetEventResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/trials/{trial_id}/events/{event_id}',
    ...options
});

/**
 * Acknowledge a notification event.
 */
export const acknowledgeEvent = <ThrowOnError extends boolean = false>(options: Options<AcknowledgeEventData, ThrowOnError>) => (options.client ?? client).patch<AcknowledgeEventResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/trials/{trial_id}/events/{event_id}/acknowledge',
    ...options
});

/**
 * Resolve a notification event.
 */
export const resolveEvent = <ThrowOnError extends boolean = false>(options: Options<ResolveEventData, ThrowOnError>) => (options.client ?? client).patch<ResolveEventResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/trials/{trial_id}/events/{event_id}/resolve',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getTrialLiveFeed = <ThrowOnError extends boolean = false>(options: Options<GetTrialLiveFeedData, ThrowOnError>) => (options.client ?? client).get<GetTrialLiveFeedResponses, GetTrialLiveFeedErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/trials/{trial_id}/live-feed',
    ...options
});

/**
 * List notification profiles for a trial.
 */
export const listProfiles = <ThrowOnError extends boolean = false>(options: Options<ListProfilesData, ThrowOnError>) => (options.client ?? client).get<ListProfilesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/trials/{trial_id}/notification-profiles',
    ...options
});

/**
 * Create a custom notification profile.
 */
export const createProfile = <ThrowOnError extends boolean = false>(options: Options<CreateProfileData, ThrowOnError>) => (options.client ?? client).post<CreateProfileResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/trials/{trial_id}/notification-profiles',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a custom notification profile.
 */
export const deleteProfile = <ThrowOnError extends boolean = false>(options: Options<DeleteProfileData, ThrowOnError>) => (options.client ?? client).delete<DeleteProfileResponses, unknown, ThrowOnError>({ url: '/api/v1/trials/{trial_id}/notification-profiles/{profile_id}', ...options });

/**
 * Get a single notification profile.
 */
export const getProfile2 = <ThrowOnError extends boolean = false>(options: Options<GetProfile2Data, ThrowOnError>) => (options.client ?? client).get<GetProfile2Responses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/trials/{trial_id}/notification-profiles/{profile_id}',
    ...options
});

/**
 * Update a notification profile.
 */
export const updateProfile = <ThrowOnError extends boolean = false>(options: Options<UpdateProfileData, ThrowOnError>) => (options.client ?? client).put<UpdateProfileResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/trials/{trial_id}/notification-profiles/{profile_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Preview a notification profile's email output.
 *
 * Returns one preview per distinct cadence in the profile's subscriptions,
 * populated with sample data so the user can see a realistic email.
 */
export const previewProfile = <ThrowOnError extends boolean = false>(options: Options<PreviewProfileData, ThrowOnError>) => (options.client ?? client).post<PreviewProfileResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/trials/{trial_id}/notification-profiles/{profile_id}/preview',
    ...options
});

/**
 * Send a test email for a notification profile.
 *
 * Renders the same preview content and actually delivers it to the
 * specified email address. The delivery is logged with `notification_type = "test"`.
 */
export const testSendProfile = <ThrowOnError extends boolean = false>(options: Options<TestSendProfileData, ThrowOnError>) => (options.client ?? client).post<TestSendProfileResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/trials/{trial_id}/notification-profiles/{profile_id}/test-send',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get notification settings for a trial (returns defaults if no row exists).
 */
export const getSettings = <ThrowOnError extends boolean = false>(options: Options<GetSettingsData, ThrowOnError>) => (options.client ?? client).get<GetSettingsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/trials/{trial_id}/notification-settings',
    ...options
});

/**
 * Upsert notification settings for a trial.
 */
export const upsertSettings = <ThrowOnError extends boolean = false>(options: Options<UpsertSettingsData, ThrowOnError>) => (options.client ?? client).put<UpsertSettingsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/trials/{trial_id}/notification-settings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List participants for a trial (paginated).
 *
 * Returns participants with pagination, sorting, and search.
 * Participants belong to cohorts which belong to trials, so this
 * filters by finding cohorts for the trial first.
 * Supports additional filters: `cohort_id`, `site_id`.
 */
export const listParticipants = <ThrowOnError extends boolean = false>(options: Options<ListParticipantsData, ThrowOnError>) => (options.client ?? client).get<ListParticipantsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/trials/{trial_id}/participants',
    ...options
});

/**
 * Create a new participant within a trial.
 *
 * The enrollment token is auto-generated. The cohort and site must both
 * belong to the specified trial.
 */
export const createParticipant = <ThrowOnError extends boolean = false>(options: Options<CreateParticipantData, ThrowOnError>) => (options.client ?? client).post<CreateParticipantResponses, CreateParticipantErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/trials/{trial_id}/participants',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bulk import participants into a trial.
 *
 * Validates all participants first. If `dry_run` is true, returns what would
 * happen without inserting. If false, inserts valid participants and skips
 * duplicates.
 */
export const bulkImportParticipants = <ThrowOnError extends boolean = false>(options: Options<BulkImportParticipantsData, ThrowOnError>) => (options.client ?? client).post<BulkImportParticipantsResponses, BulkImportParticipantsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/trials/{trial_id}/participants/bulk-import',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generate enrollment forms for participants.
 *
 * Generates enrollment forms as PDF or JSON and returns the file directly.
 */
export const generateEnrollmentForms = <ThrowOnError extends boolean = false>(options: Options<GenerateEnrollmentFormsData, ThrowOnError>) => (options.client ?? client).post<GenerateEnrollmentFormsResponses, GenerateEnrollmentFormsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/trials/{trial_id}/participants/enrollment-forms/generate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Nested DELETE: `/trials/{trial_id}/participants/{participant_id}`
 */
export const deleteTrialParticipant = <ThrowOnError extends boolean = false>(options: Options<DeleteTrialParticipantData, ThrowOnError>) => (options.client ?? client).delete<DeleteTrialParticipantResponses, DeleteTrialParticipantErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/trials/{trial_id}/participants/{participant_id}',
    ...options
});

/**
 * Get a participant within a trial context.
 *
 * Verifies the participant belongs to the trial (via cohort) and returns
 * the participant with enriched trial context (trial name, cohort name).
 */
export const getTrialParticipant = <ThrowOnError extends boolean = false>(options: Options<GetTrialParticipantData, ThrowOnError>) => (options.client ?? client).get<GetTrialParticipantResponses, GetTrialParticipantErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/trials/{trial_id}/participants/{participant_id}',
    ...options
});

/**
 * Nested PUT: `/trials/{trial_id}/participants/{participant_id}`
 */
export const updateTrialParticipant = <ThrowOnError extends boolean = false>(options: Options<UpdateTrialParticipantData, ThrowOnError>) => (options.client ?? client).put<UpdateTrialParticipantResponses, UpdateTrialParticipantErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/trials/{trial_id}/participants/{participant_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get enrollment status for a participant.
 *
 * Returns enrollment status, activation date, and masked token information.
 */
export const getEnrollment = <ThrowOnError extends boolean = false>(options: Options<GetEnrollmentData, ThrowOnError>) => (options.client ?? client).get<GetEnrollmentResponses, GetEnrollmentErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/trials/{trial_id}/participants/{participant_id}/enrollment',
    ...options
});

/**
 * Get health summary for a participant across all assigned devices.
 */
export const getParticipantHealth = <ThrowOnError extends boolean = false>(options: Options<GetParticipantHealthData, ThrowOnError>) => (options.client ?? client).get<GetParticipantHealthResponses, GetParticipantHealthErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/trials/{trial_id}/participants/{participant_id}/health',
    ...options
});

/**
 * Get medication slots for a participant.
 *
 * Returns slot assignments with medication requirement details.
 */
export const getMedicationSlots2 = <ThrowOnError extends boolean = false>(options: Options<GetMedicationSlots2Data, ThrowOnError>) => (options.client ?? client).get<GetMedicationSlots2Responses, GetMedicationSlots2Errors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/trials/{trial_id}/participants/{participant_id}/medication-slots',
    ...options
});

/**
 * Send push notifications to participants in a trial.
 */
export const pushSend = <ThrowOnError extends boolean = false>(options: Options<PushSendData, ThrowOnError>) => (options.client ?? client).post<PushSendResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/trials/{trial_id}/push-send',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get push notification status for a trial.
 */
export const getPushStatus = <ThrowOnError extends boolean = false>(options: Options<GetPushStatusData, ThrowOnError>) => (options.client ?? client).get<GetPushStatusResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/trials/{trial_id}/push-status',
    ...options
});

/**
 * List all sites for a trial (paginated).
 *
 * Returns sites with pagination, sorting, and search.
 * Supports filtering by status: "active" (default), "archived", or "all".
 */
export const listSites = <ThrowOnError extends boolean = false>(options: Options<ListSitesData, ThrowOnError>) => (options.client ?? client).get<ListSitesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/trials/{trial_id}/sites',
    ...options
});

/**
 * Create a new site within a trial.
 *
 * Slug is auto-generated from the site name. Parent trial must not be archived.
 */
export const createSite = <ThrowOnError extends boolean = false>(options: Options<CreateSiteData, ThrowOnError>) => (options.client ?? client).post<CreateSiteResponses, CreateSiteErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/trials/{trial_id}/sites',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Smart delete a site.
 *
 * Calculates deletion strategy based on resource state:
 * - **No participants** → hard delete (permanent removal)
 * - **Has participants** → archive (soft delete)
 * - **Already archived** → error (must unarchive first)
 *
 * Requires system admin permission.
 */
export const deleteSite = <ThrowOnError extends boolean = false>(options: Options<DeleteSiteData, ThrowOnError>) => (options.client ?? client).delete<DeleteSiteResponses, DeleteSiteErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/trials/{trial_id}/sites/{id}',
    ...options
});

/**
 * Get a site by ID.
 *
 * Verifies the site belongs to the specified trial.
 */
export const getSite = <ThrowOnError extends boolean = false>(options: Options<GetSiteData, ThrowOnError>) => (options.client ?? client).get<GetSiteResponses, GetSiteErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/trials/{trial_id}/sites/{id}',
    ...options
});

/**
 * Update a site (PUT).
 *
 * When the name changes, the slug is regenerated automatically.
 * Parent trial must not be archived.
 */
export const updateSite = <ThrowOnError extends boolean = false>(options: Options<UpdateSiteData, ThrowOnError>) => (options.client ?? client).put<UpdateSiteResponses, UpdateSiteErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/trials/{trial_id}/sites/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send a study message to participants via push notification.
 *
 * Creates a study message record and sends push notifications to
 * targeted participants. The message appears in the app's message
 * inbox (routed via `data.type = "study_message"`).
 */
export const sendStudyMessage = <ThrowOnError extends boolean = false>(options: Options<SendStudyMessageData, ThrowOnError>) => (options.client ?? client).post<SendStudyMessageResponses, SendStudyMessageErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/trials/{trial_id}/study-message',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update the current user's profile.
 *
 * Allows updating name and/or email. Email must be unique across all users.
 */
export const updateProfile2 = <ThrowOnError extends boolean = false>(options: Options<UpdateProfile2Data, ThrowOnError>) => (options.client ?? client).put<UpdateProfile2Responses, UpdateProfile2Errors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/me',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Disable two-factor authentication.
 *
 * Requires a valid TOTP code for security verification before disabling.
 */
export const disable2Fa = <ThrowOnError extends boolean = false>(options: Options<Disable2FaData, ThrowOnError>) => (options.client ?? client).post<Disable2FaResponses, Disable2FaErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/me/2fa/disable',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Enable two-factor authentication.
 *
 * Requires a valid TOTP code from the authenticator app to confirm
 * the secret was correctly set up.
 */
export const enable2Fa = <ThrowOnError extends boolean = false>(options: Options<Enable2FaData, ThrowOnError>) => (options.client ?? client).post<Enable2FaResponses, Enable2FaErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/me/2fa/enable',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generate a TOTP secret for 2FA setup.
 *
 * Returns the secret and a provisioning URI for QR code generation.
 * The secret is stored but 2FA is not enabled until confirmed with
 * `POST /2fa/enable`.
 */
export const generate2Fa = <ThrowOnError extends boolean = false>(options?: Options<Generate2FaData, ThrowOnError>) => (options?.client ?? client).post<Generate2FaResponses, Generate2FaErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/me/2fa/generate',
    ...options
});

/**
 * Get the current user's accessible resources for a given type.
 *
 * Returns all resource IDs the authenticated user has permissions on
 * for the requested resource type.
 */
export const getMyAccessibleResources = <ThrowOnError extends boolean = false>(options: Options<GetMyAccessibleResourcesData, ThrowOnError>) => (options.client ?? client).get<GetMyAccessibleResourcesResponses, GetMyAccessibleResourcesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/me/accessible-resources',
    ...options
});

/**
 * List the current user's registered passkeys.
 */
export const listPasskeys = <ThrowOnError extends boolean = false>(options?: Options<ListPasskeysData, ThrowOnError>) => (options?.client ?? client).get<ListPasskeysResponses, ListPasskeysErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/me/passkeys',
    ...options
});

/**
 * Complete passkey registration.
 *
 * Verifies the credential response and stores the passkey in the database.
 */
export const registerFinish = <ThrowOnError extends boolean = false>(options: Options<RegisterFinishData, ThrowOnError>) => (options.client ?? client).post<RegisterFinishResponses, RegisterFinishErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/me/passkeys/register/finish',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start passkey registration.
 *
 * Returns `WebAuthn` creation options that the browser passes to
 * `navigator.credentials.create()`. Challenge state is stored in the cache.
 */
export const registerStart = <ThrowOnError extends boolean = false>(options: Options<RegisterStartData, ThrowOnError>) => (options.client ?? client).post<RegisterStartResponses, RegisterStartErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/me/passkeys/register/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a registered passkey.
 */
export const deletePasskey = <ThrowOnError extends boolean = false>(options: Options<DeletePasskeyData, ThrowOnError>) => (options.client ?? client).delete<DeletePasskeyResponses, DeletePasskeyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/me/passkeys/{passkey_id}',
    ...options
});

/**
 * Change the current user's password.
 *
 * Requires the current password for verification. The new password must
 * meet strength requirements (uppercase, lowercase, digit, special character).
 */
export const changePassword = <ThrowOnError extends boolean = false>(options: Options<ChangePasswordData, ThrowOnError>) => (options.client ?? client).put<ChangePasswordResponses, ChangePasswordErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/me/password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get the current user's permission summary.
 *
 * Returns all direct and inherited permissions for the authenticated user.
 */
export const getMyPermissions = <ThrowOnError extends boolean = false>(options?: Options<GetMyPermissionsData, ThrowOnError>) => (options?.client ?? client).get<GetMyPermissionsResponses, GetMyPermissionsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/me/permissions',
    ...options
});

/**
 * Check multiple permissions for the current user.
 *
 * Returns whether each requested permission is granted and the source
 * of the grant (system admin, direct grant, or inherited from parent).
 */
export const checkMyPermissions = <ThrowOnError extends boolean = false>(options: Options<CheckMyPermissionsData, ThrowOnError>) => (options.client ?? client).post<CheckMyPermissionsResponses, CheckMyPermissionsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/me/permissions/check',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
